module.exports = __webpack_public_path__ + "media/images/ADC_favicon-603da727b4bc77af3613fd63b038d3e7.png";